module.exports = __webpack_public_path__ + "static/media/pichu.79238288.png";